import * as React from 'react';

// tslint:disable:max-line-length
export const WaterSystemIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M4 11.2C4 8.9 8 5 8 5s4 3.9 4 6.2c0 2.4-2.1 3.8-4 3.8s-4-1.4-4-3.8zM0 4.7C0 3.3 1.997 1 1.997 1s1.998 2.3 1.998 3.7C4.085 6.2 2.996 7 1.997 7 1 7 0 6.2 0 4.7zM16 4.7C16 3.3 14 1 14 1s-2 2.3-2 3.7C12 6.2 13.09 7 14 7c.91 0 2-.8 2-2.3z" />
    </g>
  </svg>
);
